import { DeviceType } from '../../types/DeviceType';

export const AFFIRM_MODAL_URL =
  'https://cdn1.affirm.com/platform/public/promos/assets/wixbuynowpaylater.html';

export const AFFIRM_MODAL_SIZE = {
  [DeviceType.Desktop]: {
    width: 610,
    height: 610,
  },
  // workaround to open modal to 100%, openModal doesn't support string values
  // https://wix.slack.com/archives/CAKBA7TDH/p1604926273350300?thread_ts=1604922926.343800&cid=CAKBA7TDH
  [DeviceType.Mobile]: {
    width: 2000,
    height: 2000,
  },
};
